import React from "react"
import Edges from "../../Edges"
import parse from "html-react-parser"

interface IProductOverview {
  groups: { rows: Array<any>; title: string }[]
  productOverviewHeading: string
}

const ProductOverview: React.FC<IProductOverview> = ({
  groups,
  productOverviewHeading,
}) => {
  return (
    <Edges size="md">
      <div className="mb-[60px]">
        <h2 className="mb-[25px] px-[15px] text-darkBlue xl:px-0">
          {productOverviewHeading}
        </h2>

        {groups?.map((row, index) => {
          return (
            <div key={index} className="px-[15px] xl:px-0">
              {row?.title && (
                <h4 className="mb-[19px] text-darkBlue">{row.title}</h4>
              )}
              {row?.rows?.map((row, index) => {
                return (
                  <div key={index} className="flex flex-col">
                    <div
                      className={
                        index % 2 !== 0
                          ? "grid grid-cols-3  rounded-[3px] bg-white py-3 px-3 px-[16px] xl:grid-cols-5 xl:px-6"
                          : "grid grid-cols-3  rounded-[3px] bg-lightGrey py-3 px-3 px-[16px] xl:grid-cols-5 xl:px-6 "
                      }
                    >
                      {row?.label && (
                        <div className="col-span-1 my-auto text-body2 font-black leading-4 text-darkGrey">
                          {row.label}
                        </div>
                      )}
                      {row?.value && (
                        <div className="col-span-2 break-words text-body2 text-darkGrey xl:col-span-4">
                          {row.value.includes("http") ? (
                            <a
                              className="underline hover:text-darkBlue"
                              href={row.value}
                            >
                              {parse(row.value)}
                            </a>
                          ) : (
                            parse(row.value)
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                )
              })}
              {index + 1 !== groups?.length && (
                <div className="mb-[25px] border-t-[2px] border-lightGrey"></div>
              )}
            </div>
          )
        })}
      </div>
    </Edges>
  )
}

export default ProductOverview
